import React, { Component } from 'react';
import { DateRange } from 'react-date-range';

//import {es} from 'date-fns/locale';
import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
//import ListItemIcon from '@material-ui/core/ListItemIcon';
//import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

class Period extends Component {
    constructor(props) {
        super(props);
        var interval=true
        var reportBoolean=false
        var begin=new Date()
        var final=new Date()
        if(typeof(this.props.interval)!=="undefined" && this.props.interval==="day"){
            interval=false
        }
        if(this.props.interval===false){
            interval=false
        }
        if(typeof(this.props.reportBoolean)!=="undefined"&&this.props.reportBoolean!==false){
            reportBoolean=true
            begin=moment().subtract({"months":1}).startOf('month')._d
            final=moment().subtract({"months":1}).endOf('month')._d
        }
        //console.log("calendar", reportBoolean)
        this.state = {
            open: false,
            range: {},
            dateRange: {
                selection: {
                    startDate: begin,
                    endDate: final,
                    key: 'selection',
                },
            },
            interval:interval,
            reportBoolean:reportBoolean
        }
    }
    onOpenModal = () => {
        this.setState({
            open: true,
            range: {}
        });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    onCloseModalButton = () => {
        this.setState({ open: false });
        Graph(this.props, this.state, 'custom')
    };

    handleRangeChange(which, payload) {
        const {interval, reportBoolean}=this.state
        if(interval===true){
            if(reportBoolean){
                //console.log(moment(payload.selection.startDate).startOf('month').format('YYYY-MM-DD'))
                this.setState({
                    [which]: {
                        selection:{startDate:moment(payload.selection.startDate).startOf('month').format('YYYY-MM-DD'),endDate:moment(payload.selection.startDate).endOf('month').format('YYYY-MM-DD'), key:"selection"}
                    },
                });
            }else{
                this.setState({
                    [which]: {
                        ...this.state[which],
                        ...payload,
                    },
                });
            }
            
        }else{
            if(typeof(payload.selection.startDate)!=="undefined"){
                var date=payload.selection.startDate
            }
            if(typeof(payload.selection.endDate)!=="undefined"){
                var date=payload.selection.endDate
            }
            
            this.setState({
                [which]: {
                    selection:{startDate:date,endDate:date, key:"selection"}
                },
            });
        }
        
    }
    
    render() {
        const { open , interval, reportBoolean} = this.state;
        //console.log(reportBoolean)
        var beginCalendar=0
        var finalCalendar=-6
        if(reportBoolean){
            beginCalendar=-1
            finalCalendar=-7
        }
        return (
            <div>
                <List>
                    {reportBoolean?null:
                    <ListItem>
                            <Button onClick={() => Graph(this.props, this.state, 'dia')} className="button muted-button">Último Día</Button>
                    </ListItem>}
                    {interval?
                        reportBoolean?null:
                        <ListItem>
                            <Button onClick={() => Graph(this.props, this.state, '3dia')} className="button muted-button">Últimos 3 Días</Button>
                        </ListItem>
                    :null}
                    {interval?
                        reportBoolean?null:
                        <ListItem>
                                <Button onClick={() => Graph(this.props, this.state, 'semana')} className="button muted-button">Última Semana</Button>
                        </ListItem>
                    :null}
                    <ListItem>
                        <Button onClick={this.onOpenModal}>Custom</Button>
                        <Popover open={open} 
                                onClose={this.onCloseModal} 
                                anchorOrigin={{vertical: 'center', horizontal: 'center'}}
                                transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                            <div>
                                <DateRange
                                    maxDate={addDays(new Date(), beginCalendar)}
                                    minDate={addMonths(new Date(), finalCalendar)}
                                    locale={es}
                                    onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                    moveRangeOnFirstSelection={false}
                                    ranges={[this.state.dateRange.selection]}
                                    className={'PreviewArea'}
                                />
                            </div>
                            <Button onClick={this.onCloseModalButton}>Generar</Button>
                        </Popover>
                    </ListItem>
                </List>
            </div>
        )
    }
}

function Graph(props, state, id) {
    props.onClick(props.period, props.typeGraph, state.dateRange.selection, id)
}


export default Period;